/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMetadata = exports.loadCoordinates = exports.loadCoordinate = exports["default"] = exports.coordinateLoaded = exports.coordinateLoadFailed = exports.clearCoordinates = exports.clearCoordinate = exports.clearAll = void 0;
var _reduxActions = require("redux-actions");
var _actions = require("./actions");
var _handleActions;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {};
var DEFAULT_DATA_ID = 'data';
var setCoordinateStateData = function setCoordinateStateData(state, coordinate, data) {
  var dataId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_DATA_ID;
  var x = coordinate.x,
    y = coordinate.y;
  var coordinateData = state.coordinateData || {};
  var dataById = coordinateData[dataId] || {};
  if (typeof x === 'undefined' || typeof y === 'undefined') {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    coordinateData: _objectSpread(_objectSpread({}, coordinateData), {}, _defineProperty({}, dataId, _objectSpread(_objectSpread({}, dataById || {}), {}, _defineProperty({}, y, _objectSpread(_objectSpread({}, dataById[y] || {}), {}, _defineProperty({}, x, data))))))
  });
};
var removeCoordinateStateData = function removeCoordinateStateData(state, coordinate) {
  var dataId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_DATA_ID;
  var x = coordinate.x,
    y = coordinate.y;
  if (typeof x === 'undefined' || typeof y === 'undefined') {
    return state;
  }
  var newState = setCoordinateStateData(state, coordinate, null, dataId);
  delete newState.coordinateData[dataId][y][x];
  return newState;
};
var loadCoordinate = function loadCoordinate(state, action) {
  var _action$payload = action.payload,
    coordinate = _action$payload.coordinate,
    dataId = _action$payload.dataId;
  return setCoordinateStateData(state, coordinate, {
    isLoading: true
  }, dataId);
};
exports.loadCoordinate = loadCoordinate;
var loadCoordinates = function loadCoordinates(state, action) {
  var _action$payload2 = action.payload,
    coordinates = _action$payload2.coordinates,
    _action$payload2$data = _action$payload2.dataId,
    dataId = _action$payload2$data === void 0 ? DEFAULT_DATA_ID : _action$payload2$data;
  var coordinateData = state.coordinateData || {};
  if (!coordinates) {
    return state;
  }
  var newCoordinateData = coordinates.reduce(function (data, _ref) {
    var x = _ref.x,
      y = _ref.y;
    return _objectSpread(_objectSpread({}, data), {}, _defineProperty({}, y, _objectSpread(_objectSpread({}, data[y] || {}), {}, _defineProperty({}, x, {
      isLoading: true
    }))));
  }, coordinateData[dataId] || {});
  return _objectSpread(_objectSpread({}, state), {}, {
    coordinateData: _objectSpread(_objectSpread({}, state.coordinateData), {}, _defineProperty({}, dataId, newCoordinateData))
  });
};
exports.loadCoordinates = loadCoordinates;
var coordinateLoaded = function coordinateLoaded(state, action) {
  var _action$payload3 = action.payload,
    coordinate = _action$payload3.coordinate,
    data = _action$payload3.data,
    dataId = _action$payload3.dataId;
  return setCoordinateStateData(state, coordinate, {
    data: data,
    isLoaded: true
  }, dataId);
};
exports.coordinateLoaded = coordinateLoaded;
var coordinateLoadFailed = function coordinateLoadFailed(state, action) {
  var _action$payload4 = action.payload,
    coordinate = _action$payload4.coordinate,
    data = _action$payload4.data,
    dataId = _action$payload4.dataId;
  return setCoordinateStateData(state, coordinate, {
    error: data
  }, dataId);
};
exports.coordinateLoadFailed = coordinateLoadFailed;
var clearCoordinate = function clearCoordinate(state, action) {
  var _action$payload5 = action.payload,
    coordinate = _action$payload5.coordinate,
    dataId = _action$payload5.dataId;
  return removeCoordinateStateData(state, coordinate, dataId);
};
exports.clearCoordinate = clearCoordinate;
var clearCoordinates = function clearCoordinates(state, action) {
  var _action$payload6 = action.payload,
    coordinates = _action$payload6.coordinates,
    dataId = _action$payload6.dataId;
  return coordinates.reduce(function (newState, coordinate) {
    return removeCoordinateStateData(newState, coordinate, dataId);
  }, state);
};
exports.clearCoordinates = clearCoordinates;
var clearAll = function clearAll(state, action) {
  var _ref2 = action.payload || {},
    dataId = _ref2.dataId;
  if (dataId) {
    var newState = _objectSpread(_objectSpread({}, state), {}, {
      coordinateData: _objectSpread({}, state.coordinateData || {})
    });
    delete newState.coordinateData[dataId];
    return newState;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    coordinateData: {}
  });
};
exports.clearAll = clearAll;
var setMetadata = function setMetadata(state, action) {
  var _action$payload7 = action.payload,
    metadata = _action$payload7.metadata,
    _action$payload7$data = _action$payload7.dataId,
    dataId = _action$payload7$data === void 0 ? DEFAULT_DATA_ID : _action$payload7$data;
  return _objectSpread(_objectSpread({}, state), {}, {
    metadata: _objectSpread(_objectSpread({}, state.metadata), {}, _defineProperty({}, dataId, metadata))
  });
};
exports.setMetadata = setMetadata;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _actions.LOAD_COORDINATE, loadCoordinate), _defineProperty(_handleActions, _actions.LOAD_COORDINATES, loadCoordinates), _defineProperty(_handleActions, _actions.COORDINATE_LOADED, coordinateLoaded), _defineProperty(_handleActions, _actions.LOAD_COORDINATE_FAILED, coordinateLoadFailed), _defineProperty(_handleActions, _actions.CLEAR_COORDINATE, clearCoordinate), _defineProperty(_handleActions, _actions.CLEAR_COORDINATES, clearCoordinates), _defineProperty(_handleActions, _actions.CLEAR_ALL, clearAll), _defineProperty(_handleActions, _actions.SET_METADATA, setMetadata), _handleActions), initialState);
var _default = reducer;
exports["default"] = _default;